import gmailLogo from '../../../assets/connectors/gmail.png';

const UNKNOWN = '—';

/** v1 reaches creators by email only, so the channel is the email mark when there is an address. */
export function CrmChannelCell({ hasContact }: { hasContact: boolean }) {
  if (!hasContact) {
    return (
      <span className="text-muted-foreground">
        <span aria-hidden>{UNKNOWN}</span>
        <span className="sr-only">No email</span>
      </span>
    );
  }
  return <img src={gmailLogo} alt="Email" title="Email" className="h-3.5 w-auto" />;
}
